import React, { useState, useEffect } from 'react';
import { useTranslation } from 'react-i18next';
import Popup from 'reactjs-popup';
import { useWindowSize } from '../Common/CommonHooks';

const ErrorPopup = ({errorType, handleClickCancel, setShowErrorPopup}) => {
    const { t, i18n } = useTranslation();

    const { isMobileSize } = useWindowSize();
    let mobileStyle = isMobileSize ? 'is-mobile' : 'is-desktop';
    useEffect(() => {
        if (isMobileSize) {
            mobileStyle = 'is-mobile'
        } else {
            mobileStyle = 'is-desktop';
        }
    }, [isMobileSize]);

    
    let errorTypeParsed = errorType.includes('|')? errorType.split('|')[0] : errorType;
    let errorCode = errorType.includes('|')? errorType.split('|')[1] : null;

    let errorTitle = t('LS_BS_ERRORPOPUP_BUSY_TITLE');
    let errorMessage = t('LS_BS_ERRORPOPUP_BUSY_MESSAGE');

    switch(errorTypeParsed) {
        case 'session timeout':
            errorTitle = t('LS_BS_ERRORPOPUP_TIMEOUT_TITLE');
            errorMessage = t('LS_BS_ERRORPOPUP_TIMEOUT_MESSAGE');
            break;
        case 'network':
        case '100019':
        case '100020':
            errorTitle = t('LS_BS_ERRORPOPUP_BUSY_TITLE');
            errorMessage = t('LS_BS_ERRORPOPUP_BUSY_MESSAGE');
            break;
        case 'exception':
            errorTitle = t('LS_BS_ERRORPOPUP_BUSY_TITLE');
            errorMessage = t('LS_BS_LOGIN_ERROR_CIAM_ERROR');
            break;
        case '100003':
            errorTitle = t('LS_BS_ERRORPOPUP_BUSY_TITLE');
            errorMessage = t('LB_BS_LOGIN_ERROR_CIAM_100003');
            errorCode = "100003";
            break;
        case '100021':
            errorTitle = t('LS_BS_ERRORPOPUP_OTPLIMIT_TITLE');
            errorMessage = t('LB_BS_LOGIN_ERROR_CIAM_100021');
            errorCode = "100021";
            break;
        default:
            errorTitle = t('LS_BS_ERRORPOPUP_BUSY_TITLE');
            errorMessage = t('LS_BS_LOGIN_ERROR_CIAM_ERROR');
    }
    const handleClickClose = () => {
        let errorTypeParsed = errorType.includes('|')? errorType.split('|')[0] : errorType;

        // only close the popup if error occurs when trusting browser
        if (errorTypeParsed === 'trust browser failure'||errorTypeParsed === 'session timeout' || errorTypeParsed === '110') {
            setShowErrorPopup(false);
        }
        handleClickCancel(errorTypeParsed);
    }

    const parseErrorCode = (errorCode) => {
        if (errorCode != null && errorCode !== undefined && errorCode !== 'undefined') {
            return ' ('+ errorCode + ')';
        }
        return '';
    }
    
    return (
        <Popup open={true} closeOnDocumentClick={false} className={`errorpopup ${mobileStyle}`} onClose={handleClickClose}>
            <div className="errorpopup-container" id="errorpopup">
                <div className="errorpopup-title">{errorTitle}</div>
                <div className="errorpopup-message">{errorMessage} {parseErrorCode(errorCode)}</div>
                <div className={`button-box errorpopup-btn-grp`}>
                    <div className='row2'>
                        <div className="errorpopup-close" onClick={handleClickClose}>{t('LB_CLOSE')}</div>
                    </div>
                </div>
            </div>
        </Popup>
    )
}

export default ErrorPopup;